import { defineComponent } from 'vue-demi';
import { OrIcon, useResponsive } from '@onereach/ui-components';
import { openBlock, createElementBlock, createElementVNode, normalizeClass, toDisplayString, resolveComponent, Fragment, renderList, createBlock, withCtx, createVNode, createCommentVNode, pushScopeId, popScopeId } from 'vue';
import { s as styleInject } from './style-inject.es-20d2f1f5.js';
import { s as script$4 } from './ServiceNavigationMenu-9bf50cbf.js';
import _ from 'lodash';
import { useToggle } from '@vueuse/core';

const TAIL_LENGTH = 3 + 1;
var script$3 = defineComponent({
  name: 'ServiceNavigationBreadcrumbLabel',
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    isWhiteSpace() {
      if (this.labelEllipsis.endsWith(' ') || this.labelEnd.startsWith(' ')) {
        return '&nbsp;';
      }
      return '';
    },
    labelEllipsis() {
      const slicedLabel = this.label.slice(0, -TAIL_LENGTH);
      return slicedLabel;
    },
    labelEnd() {
      const index = this.label.length - TAIL_LENGTH;
      return index > 0 ? this.label.substr(index) : this.label;
    }
  }
});

const _hoisted_1$3 = {
  class: "container"
};
const _hoisted_2$1 = ["innerHTML"];
const _hoisted_3$1 = {
  class: "sn-link"
};
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$3, [createElementVNode("span", {
    class: normalizeClass([{
      'sn-link-ellipsis': _ctx.labelEllipsis.length > 5
    }, 'sn-link'])
  }, toDisplayString(_ctx.labelEllipsis), 3 /* TEXT, CLASS */), createElementVNode("span", {
    innerHTML: _ctx.isWhiteSpace
  }, null, 8 /* PROPS */, _hoisted_2$1), createElementVNode("span", _hoisted_3$1, toDisplayString(_ctx.labelEnd), 1 /* TEXT */)]);
}

var css_248z$3 = ".container[data-v-4c400210] {\n  display: flex;\n  min-width: 0;\n}\n.container .sn-link-ellipsis[data-v-4c400210] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.container .sn-link[data-v-4c400210] {\n  text-decoration: none;\n  white-space: nowrap;\n}";
styleInject(css_248z$3);

script$3.render = render$3;
script$3.__scopeId = "data-v-4c400210";
script$3.__file = "src/components/ServiceNavigationBreadcrumbLabel.vue";

var script$2 = defineComponent({
  name: 'ServiceNavigationBreadcrumbs',
  components: {
    OrIcon,
    ServiceNavigationBreadcrumbLabel: script$3
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    inverted: {
      type: Boolean,
      default: false
    }
  }
});

const _hoisted_1$2 = {
  key: 2,
  class: "sn-link"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_service_navigation_breadcrumb_label = resolveComponent("service-navigation-breadcrumb-label");
  const _component_router_link = resolveComponent("router-link");
  const _component_or_icon = resolveComponent("or-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass({
      'breadcrumbs': true,
      'inverted': _ctx.inverted
    }),
    "data-test": "breadcrumbs"
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (breadcrumb, index) => {
    return openBlock(), createElementBlock("div", {
      key: breadcrumb.label,
      class: "breadcrumb-item",
      "data-test": "breadcrumb-item"
    }, [index !== _ctx.items.length - 1 ? (openBlock(), createBlock(_component_router_link, {
      key: 0,
      class: "sn-link",
      to: breadcrumb.to
    }, {
      default: withCtx(() => [createVNode(_component_service_navigation_breadcrumb_label, {
        label: breadcrumb.label
      }, null, 8 /* PROPS */, ["label"])]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])) : createCommentVNode("v-if", true), index !== _ctx.items.length - 1 ? (openBlock(), createBlock(_component_or_icon, {
      key: 1,
      class: "chevron",
      icon: "chevron_right"
    })) : (openBlock(), createElementBlock("span", _hoisted_1$2, [createVNode(_component_service_navigation_breadcrumb_label, {
      label: breadcrumb.label
    }, null, 8 /* PROPS */, ["label"])]))]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */);
}

var css_248z$2 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-5cdae38c {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-5cdae38c {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.breadcrumbs[data-v-5cdae38c] {\n  display: flex;\n  min-width: 10px;\n  max-width: 100%;\n  height: 100%;\n}\n.breadcrumbs[data-v-5cdae38c] .chevron {\n  font-size: 1rem;\n  color: var(--c-neutral-5);\n}\n.breadcrumbs.inverted .sn-link[data-v-5cdae38c]:hover {\n  color: var(--c-neutral-6);\n}\n.breadcrumbs.inverted .sn-link[data-v-5cdae38c]:last-child {\n  color: var(--c-neutral-6);\n  pointer-events: none;\n  cursor: default;\n}\n.breadcrumbs .breadcrumb-item[data-v-5cdae38c] {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  max-width: 100%;\n}\n.breadcrumbs .breadcrumb-item[data-v-5cdae38c]:first-child {\n  min-width: fit-content;\n}\n.breadcrumbs .sn-link[data-v-5cdae38c] {\n  display: flex;\n  min-width: 0;\n  margin: 0 var(--s-6);\n  font-size: 12px;\n  font-weight: bold;\n  color: var(--c-neutral-5);\n  text-decoration: none;\n}\n.breadcrumbs .sn-link[data-v-5cdae38c]:hover {\n  color: var(--c-neutral-0);\n}\n.breadcrumbs .sn-link[data-v-5cdae38c]:last-child {\n  color: var(--c-neutral-0);\n  pointer-events: none;\n  cursor: default;\n}";
styleInject(css_248z$2);

script$2.render = render$2;
script$2.__scopeId = "data-v-5cdae38c";
script$2.__file = "src/components/ServiceNavigationBreadcrumb.vue";

var script$1 = defineComponent({
  name: 'ServiceNavigationBreadcrumbMobile',
  components: {
    OrIcon,
    ServiceNavigationBreadcrumbLabel: script$3
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    inverted: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const [showMore, toggle] = useToggle();
    return {
      showMore,
      toggle
    };
  },
  computed: {
    lastItem() {
      return _.last(this.items);
    },
    firstItem() {
      return _.first(this.items);
    },
    middleItems() {
      return _.tail(_.initial(this.items));
    }
  },
  methods: {
    labelEllipsis(label) {
      return label.slice(0, -4);
    },
    labelEnd(label) {
      return label.substr(label.length - 4);
    }
  }
});

const _withScopeId = n => (pushScopeId("data-v-48a6a84e"), n = n(), popScopeId(), n);
const _hoisted_1$1 = {
  class: "container"
};
const _hoisted_2 = {
  key: 0,
  class: "breadcrumb-item",
  "data-test": "breadcrumb-item"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/createElementVNode("span", {
  class: "dots"
}, "...", -1 /* HOISTED */));
const _hoisted_4 = {
  key: 2,
  class: "breadcrumb-item",
  "data-test": "breadcrumb-item"
};
const _hoisted_5 = {
  class: "sn-link"
};
const _hoisted_6 = {
  key: 0,
  class: "more-items-container",
  "data-test": "breadcrumb-more-container"
};
const _hoisted_7 = {
  class: "more-items-container-list"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_service_navigation_breadcrumb_label = resolveComponent("service-navigation-breadcrumb-label");
  const _component_router_link = resolveComponent("router-link");
  const _component_or_icon = resolveComponent("or-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass({
      'breadcrumbs-mobile': true,
      'inverted': _ctx.inverted
    }),
    "data-test": "breadcrumbs-mobile"
  }, [createElementVNode("div", _hoisted_1$1, [_ctx.firstItem ? (openBlock(), createElementBlock("div", _hoisted_2, [createVNode(_component_router_link, {
    class: "sn-link",
    to: _ctx.firstItem.to
  }, {
    default: withCtx(() => [createVNode(_component_service_navigation_breadcrumb_label, {
      label: _ctx.firstItem.label
    }, null, 8 /* PROPS */, ["label"])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["to"])])) : createCommentVNode("v-if", true), _ctx.middleItems.length > 0 ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: "breadcrumb-item toggle-trigger",
    "data-test": "breadcrumb-more-trigger",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.toggle && _ctx.toggle(...arguments);
    })
  }, [createVNode(_component_or_icon, {
    class: "chevron",
    icon: "chevron_right"
  }), createCommentVNode(" eslint-disable-next-line @intlify/vue-i18n/no-raw-text "), _hoisted_3])) : createCommentVNode("v-if", true), _ctx.lastItem ? (openBlock(), createElementBlock("div", _hoisted_4, [createVNode(_component_or_icon, {
    class: "chevron",
    icon: "chevron_right"
  }), createElementVNode("span", _hoisted_5, [createVNode(_component_service_navigation_breadcrumb_label, {
    label: _ctx.lastItem.label
  }, null, 8 /* PROPS */, ["label"])])])) : createCommentVNode("v-if", true)]), _ctx.showMore ? (openBlock(), createElementBlock("div", _hoisted_6, [createElementVNode("div", _hoisted_7, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.middleItems, breadcrumb => {
    return openBlock(), createElementBlock("div", {
      key: breadcrumb.label,
      class: "breadcrumb-item",
      "data-test": "breadcrumb-more-item"
    }, [createVNode(_component_router_link, {
      class: "sn-link",
      to: breadcrumb.to
    }, {
      default: withCtx(() => [createVNode(_component_service_navigation_breadcrumb_label, {
        label: breadcrumb.label
      }, null, 8 /* PROPS */, ["label"])]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])]);
  }), 128 /* KEYED_FRAGMENT */))])])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z$1 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-48a6a84e {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-48a6a84e {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.breadcrumbs-mobile[data-v-48a6a84e] {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n.breadcrumbs-mobile.inverted .sn-link[data-v-48a6a84e]:hover {\n  color: var(--c-neutral-6);\n}\n.breadcrumbs-mobile > .container[data-v-48a6a84e] {\n  display: flex;\n  padding: 0 18px;\n  overflow: hidden;\n}\n.breadcrumbs-mobile > .container .breadcrumb-item[data-v-48a6a84e] .chevron {\n  font-size: 1rem;\n  color: var(--c-neutral-5);\n}\n.breadcrumbs-mobile > .container .breadcrumb-item[data-v-48a6a84e]:first-child {\n  min-width: fit-content;\n}\n.breadcrumbs-mobile > .container .breadcrumb-item:last-child .sn-link[data-v-48a6a84e] {\n  color: var(--c-neutral-6);\n  cursor: default;\n}\n.breadcrumbs-mobile .more-items-container[data-v-48a6a84e] {\n  position: absolute;\n  top: calc(100% + 1px);\n  z-index: 51;\n  width: 100%;\n  background-color: var(--c-neutral-0);\n  border-bottom: 1px solid var(--c-neutral-2);\n}\n.breadcrumbs-mobile .more-items-container .breadcrumb-item[data-v-48a6a84e] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n}\n.breadcrumbs-mobile .breadcrumb-item[data-v-48a6a84e] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  max-width: 100%;\n}\n.breadcrumbs-mobile .breadcrumb-item.toggle-trigger[data-v-48a6a84e] {\n  display: flex;\n  min-width: 50px;\n  padding: 0 5px 0 0;\n  cursor: pointer;\n}\n.breadcrumbs-mobile .breadcrumb-item.toggle-trigger .dots[data-v-48a6a84e] {\n  font-weight: bold;\n  color: var(--c-neutral-5);\n}\n.breadcrumbs-mobile .breadcrumb-item.toggle-trigger .dots[data-v-48a6a84e]:hover {\n  color: var(--c-neutral-6);\n}\n.breadcrumbs-mobile .sn-link[data-v-48a6a84e] {\n  display: flex;\n  max-width: 90%;\n  margin: 0 auto;\n  font-size: 12px;\n  font-weight: bold;\n  color: var(--c-neutral-5);\n  text-decoration: none;\n}\n.breadcrumbs-mobile .sn-link[data-v-48a6a84e]:hover {\n  color: var(--c-neutral-6);\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-48a6a84e";
script$1.__file = "src/components/ServiceNavigationBreadcrumbMobile.vue";

var script = defineComponent({
  name: 'ServiceNavigationFooter',
  components: {
    ServiceNavigationBreadcrumb: script$2,
    ServiceNavigationBreadcrumbMobile: script$1,
    ServiceNavigationMenu: script$4
  },
  props: {
    breadcrumbItems: {
      type: Array,
      default: () => []
    },
    menuItems: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const {
      isDesktop
    } = useResponsive();
    return {
      isDesktop
    };
  },
  computed: {
    showMenu() {
      return !this.isDesktop && this.breadcrumbItems.length <= 1 && this.menuItems.length > 0;
    },
    showBreadcrumbs() {
      return this.breadcrumbItems.length > 1;
    }
  }
});

const _hoisted_1 = {
  key: 0,
  class: "footer",
  "data-test": "service-navigation-footer"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_service_navigation_menu = resolveComponent("service-navigation-menu");
  const _component_service_navigation_breadcrumb = resolveComponent("service-navigation-breadcrumb");
  const _component_service_navigation_breadcrumb_mobile = resolveComponent("service-navigation-breadcrumb-mobile");
  return _ctx.showBreadcrumbs || _ctx.showMenu ? (openBlock(), createElementBlock("div", _hoisted_1, [_ctx.showMenu ? (openBlock(), createBlock(_component_service_navigation_menu, {
    key: 0,
    items: _ctx.menuItems,
    inverted: true
  }, null, 8 /* PROPS */, ["items"])) : createCommentVNode("v-if", true), _ctx.showBreadcrumbs && _ctx.isDesktop ? (openBlock(), createBlock(_component_service_navigation_breadcrumb, {
    key: 1,
    items: _ctx.breadcrumbItems,
    inverted: true
  }, null, 8 /* PROPS */, ["items"])) : createCommentVNode("v-if", true), _ctx.showBreadcrumbs && !_ctx.isDesktop ? (openBlock(), createBlock(_component_service_navigation_breadcrumb_mobile, {
    key: 2,
    items: _ctx.breadcrumbItems,
    inverted: true
  }, null, 8 /* PROPS */, ["items"])) : createCommentVNode("v-if", true)])) : createCommentVNode("v-if", true);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-3684f799 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-3684f799 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.footer[data-v-3684f799] {\n  height: 30px;\n  background: var(--c-neutral-0);\n  border-bottom: 1px solid var(--c-neutral-2);\n}\n@media only screen and (max-width: 768px) {\n.footer[data-v-3684f799] {\n    height: 48px;\n}\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-3684f799";
script.__file = "src/components/ServiceNavigationFooter/ServiceNavigationFooter.vue";

export { script$2 as a, script as s };
